import { FontWeights } from "styled-components";
import { cssVar, darken, em, lighten } from "polished";
import { ThemeProps } from "@app/styles/theme/tokens";

export const fontSize = (fontSize: number) => (props: ThemeProps) => em(fontSize, props.theme.defaultFontSize);

export const fontSizeBasedOn = (fontSize: number, baseOnSize: number) => (props: ThemeProps) => em(fontSize, baseOnSize);

export const fontWeight = (fontWeight: keyof FontWeights) => (props: ThemeProps) => props.theme.fontWeights[fontWeight];

export const gutter =
    (multiplicator = 1) =>
    (props: ThemeProps) =>
        `${multiplicator * props.theme.gutter}px`;

export const darkenCssVarColor = (name: string, amount: number, defaultVarValue?: string | number) =>
    darken(amount, cssVar(name, defaultVarValue ?? "#FFF") as string);

export const lightenCssVarColor = (name: string, amount: number) => lighten(amount, cssVar(name, "#f0f0f0") as string);
export const lightenCssVarColorAsExpression = (name: string, amount: number) => `hsl(from var(${name}) h s calc(l + ${100 * amount}))`;

export const rgbaCssVarColor = (name: string, amount: number) => `rgba(--var(${name}), ${amount})`;
